import { Box, Button, FileInput, Input, LoadingOverlay, Paper, Select, SimpleGrid, Space, Text, Textarea, TextInput, Title } from '@mantine/core'
import React, { memo, useEffect, useState } from 'react'
import useFetch from '../../../../Customhooks/useFetch';
import { useNavigate, useParams } from 'react-router-dom';
import { baseUrl } from '../../../../Constants/constant';
import { notifications } from '@mantine/notifications';
import classes from '../ManagePackageBox.module.css';


const Addrawmaterial = () => {
    const navigate = useNavigate();
    const [packagebox, setPackageBox] = useState<string>('');
    const [cotwo, setCoTwo] = useState<string>('');
    const [sourceName, setSourceName] = useState<string>('');
    const [description, setDescription] = useState<string>('');
    const [errors, setErrors] = useState<Record<string, string>>({});
    const token = localStorage.getItem("token")
    const { id } = useParams();
    const method = id ? 'PUT' : 'POST'
    const url = id ? `${baseUrl}admin/package-boxes/update/${id}` : `${baseUrl}admin/package-boxes/add`
    const {
        data: getData,
        loading: detailLoading,
        error: getError,
        fetchData: postPallets,
    } = useFetch({
        method: method,
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "token": token
        },
        body: JSON.stringify({
            box_name: packagebox,
            co2_embodiment: cotwo,
            source_name: sourceName,
            description: description
        }),
    });
    const {
        data: getfieldData,
        loading: getfieldLoading,
        error: getfielderror,
        fetchData: getfield,
    } = useFetch({
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "token": token
        },
    });
    useEffect(() => {
        if (id) {
            getfield(`${baseUrl}admin/package-boxes/${id}`)
        }
    }, [])
    useEffect(() => {
        if (getfieldData?.data?.rows?.length) {
            setPackageBox(getfieldData?.data?.rows[0]?.box_name || '');
            setCoTwo(getfieldData?.data?.rows[0]?.co2_embodiment || '');
            setSourceName(getfieldData?.data?.rows[0]?.source_name || '');
            setDescription(getfieldData?.data?.rows[0]?.description || '');
        }
    }, [getfieldData]);

    // **Reusable function to handle input change and remove errors**
    const handleChange = (field: string, value: string | null) => {
        if (field === "package_name") {
            setPackageBox(value as string);
        }
        else if (field === "co2_id") {
            setCoTwo(value as string);
        }
        else if (field === "source_name") {
            setSourceName(value as string);
        }
        else if (field === "description") {
            setDescription(value as string);
        }

        // Remove the error for the field if it's being updated
        setErrors((prev: any) => ({ ...prev, [field]: undefined }));
    };

    // **Validate inputs before submitting**
    const validateFields = () => {
        let newErrors: Record<string, string> = {};

        if (!packagebox.trim()) {
            newErrors.package_name = "Package Box name is Required";
        }
        if (!cotwo) {
            newErrors.co2_id = "CO₂ is Required";
        }
        if (!sourceName) {
            newErrors.source_name = "Source Name is Required";
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return false; // Validation failed
        }
        return true; // Validation passed
    };

    const handlesave = async () => {
        if (!validateFields()) return; // Stop if validation fails
        await postPallets(url);
    };
    useEffect(() => {
        const showNotification = (type: any, title = "An error occurred") => {
            notifications.show({
                title,
                message: type === 'success'
                    ? "Transport data saved successfully."
                    : "Something went wrong. Please try again.",
                color: type === 'success' ? "green" : "red",
                classNames: classes,
            });
        };

        if (getData?.errors || getError) {
            showNotification('error', getData?.message || getError?.message);
            return;
        }

        if (getData && !getData?.errors) {
            navigate('/package-box');
        }
    }, [getData, getError, navigate, classes]);
    return (
        <>
            <LoadingOverlay
                visible={getfieldLoading}
                zIndex={1000}
                overlayProps={{
                    radius: 'sm',
                    blur: 2,
                    style: {
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%'
                    }
                }}
                loaderProps={{ color: '#404040', type: 'bars' }}
            />
            <Paper shadow="xs" p="xs" radius="md">
                <Box ml={5}>
                    <Title order={4}>Add Package Box</Title>
                    <Space h="lg" />
                    <Text>Package Box Details</Text>
                    <Space h="xs" />
                    <SimpleGrid cols={4}>
                        <TextInput
                            variant='filled'
                            label="Package Name"
                            withAsterisk
                            value={packagebox}
                            onChange={(e) => handleChange("package_name", e.target.value)}
                            placeholder="Package Name"
                            radius={6}
                            error={errors.package_name}
                        />

                        <TextInput
                            variant='filled'
                            withAsterisk
                            label="Per/Kg CO₂ Embodiment"
                            value={cotwo}
                            onChange={(e) => handleChange("co2_id", e.target.value)}
                            placeholder="Enter Embodied"
                            radius={6}
                            error={errors.co2_id}
                        />
                        <TextInput
                            variant='filled'
                            withAsterisk
                            label="Source Name"
                            value={sourceName}
                            onChange={(e) => handleChange("source_name", e.target.value)}
                            placeholder="Enter Source Name"
                            radius={6}
                            error={errors.source_name}
                        />
                        <Textarea
                            label="Source Description"
                            placeholder="Enter your Source Description"
                            variant="filled"
                            autosize
                            value={description}
                            onChange={(e) => handleChange("description", e.target.value)}
                            minRows={1}
                            maxRows={4}
                            radius={6}
                        />

                    </SimpleGrid>
                    <Space h="xl" />
                    <SimpleGrid cols={6}>
                        <Button
                            variant="default"
                            radius={6}
                            onClick={() => navigate('/package-box')}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="gradient"
                            gradient={{ from: '#404040', to: '#404040', deg: 90 }}
                            radius={6}
                            onClick={handlesave}
                            loading={detailLoading}
                        >
                            {id ? 'Update' : 'Save'}
                        </Button></SimpleGrid>
                </Box>
            </Paper>
        </>
    )
}

export default memo(Addrawmaterial)